import type { OpenQuestionFilters } from "@/infrastructure/repositories/open-questions.supabase.repository";

export const openQuestionsKeys = {
  all: ["open_questions"] as const,
  list: (filters: OpenQuestionFilters = {}) => [...openQuestionsKeys.all, "list", filters] as const,
  detail: (id: string) => [...openQuestionsKeys.all, "detail", id] as const,
};
